export const GLOBAL_SETTINGS_RESET_STATE = 'GLOBAL_SETTINGS_RESET_STATE';
export const GLOBAL_SETTINGS_CURRENT_ITEM = 'GLOBAL_SETTINGS_CURRENT_ITEM';

export const GLOBAL_SETTINGS_REQUEST_LOADING = 'GLOBAL_SETTINGS_REQUEST_LOADING';
export const GLOBAL_SETTINGS_REQUEST_SUCCESS = 'GLOBAL_SETTINGS_REQUEST_SUCCESS';
export const GLOBAL_SETTINGS_REQUEST_FAILED = 'GLOBAL_SETTINGS_REQUEST_FAILED';

export const GLOBAL_SETTINGS_CURRENT_ACTION = 'GLOBAL_SETTINGS_CURRENT_ACTION';
export const GLOBAL_SETTINGS_RESET_ACTION = 'GLOBAL_SETTINGS_RESET_ACTION';
